import { AutogenLayoutTieredChargeTableLookup } from "./autogen/AutogenLayoutTieredChargeTableLookup";

export class TieredChargeTableLookup extends AutogenLayoutTieredChargeTableLookup {
}
